import _ from "lodash";
import { colors } from "@assets/index";
import { useAppSelector } from "@src/ducks/ducksHook";
import { selectedEnableSignature, selectedDocumentParties } from "@src/ducks/slices/signsecure.slice";
import React, { memo, useContext } from "react";
import { Layer } from "react-konva";
import { SignatureContext } from "../../provider/signature";
import { CanvasContext } from "../../provider/canvas";
import Items from "./items";
import { DrawerContext } from "@src/screens/drawer-screens/drawer-provider";
import parseMoment from "moment";

type LayerCanvasProps = {
  item: any;
  layerId: number;
  documentId: string;
  onCheck: (value: any) => void;
  onTextFocus: (value: any) => void;
  onTextUpdate: (value: any) => void;
  onShowSignature: (value: any) => void;
  onShowQuickSigning: (value: any) => void;
  onShowTextBox: (value: any) => void;
}

const LayerCanvas = ({ item, layerId, documentId, onShowSignature, onShowQuickSigning, onCheck, onTextFocus, onTextUpdate, onShowTextBox }: LayerCanvasProps) => {
  const { canvas } = useContext(CanvasContext);
  const { document } = React.useContext(SignatureContext);
  const enableSignature = useAppSelector(selectedEnableSignature);
  const userParty = useAppSelector(selectedDocumentParties);
  const { steps, activeTab } = React.useContext(DrawerContext);

  const listOfSignatures = ["initials", "signature", "signature-name", "signature-date", "signature-name-designation"];
  const signatures = item.filter((itemField: any) => listOfSignatures.includes(itemField.type));
  const dates = item.filter((itemField: any) => itemField.type === 'date');
  const mergedPairs: any[] = [];
  signatures.forEach((signature: any) => {
    dates.forEach((date: any) => {
      if (signature.trackId === date.trackId) {
        mergedPairs.push({ signature, date });
      }
    });
  });

  return (
    <Layer>
      {item.map((field: any, index: number) => {
        const isReviewAndSend = steps.includes("Send");
        let shouldSign = isReviewAndSend ? !_.isEmpty(userParty) ? true : false : true;
        const isTextInput = field.type === "textinput"
        if (isTextInput) {
          return null
        }
        if(field.trackId !== userParty.trackId) {
          if (steps.includes("Sign")) {
            if (activeTab === "Create Document") {
              shouldSign = false;
            }
            else {
              return null;
            }
          }
          else if (isReviewAndSend) {
            shouldSign = false;
          }
        }
        else if (isReviewAndSend && !enableSignature) {
          shouldSign = false;
        }
        else if (document?.workflow?.status === "EXPIRED") {
          return null;
        }
        
        let signatureDateConfig = null;
        if (field.type === 'date') {
          const pair = mergedPairs.find((paired: any) => paired.date?.id === field.id);
          if (pair && pair.date && pair.signature?.dateConfig) {
            const signatureDate = pair.signature.dateConfig.text
            signatureDateConfig = {
              text: parseMoment(signatureDate, "DDMMMYYYY hh:mm:ss A").format("DDMMMYYYY"),
            };
          }
        }
        return (
          <Items
            key={index.toString()}
            signatureDateConfig={signatureDateConfig}
            field={{
              ...field,
              documentId,
              config: {
                ...field.config,
                x: field?.config?.x * canvas.scale,
                y: field?.config?.y * canvas.scale,
                width: field?.config?.width * canvas.scale,
                height: field?.config?.height * canvas.scale,
                fill: shouldSign ? field?.config?.fill : colors.signature5,
              },
              textConfig: {
                ...field.textConfig,
                fontSize: field?.textConfig?.fontSize * canvas.scale,
              },
              nameConfig: {
                ...field.nameConfig,
                y: field?.nameConfig?.y * canvas.scale,
                fontSize: field?.nameConfig?.fontSize * canvas.scale,
              },
              dateConfig: {
                ...field.dateConfig,
                y: field?.dateConfig?.y * canvas.scale,
                fontSize: field?.dateConfig?.fontSize * canvas.scale,
                fill: shouldSign ? field?.dateConfig?.fill : colors.gray11,
              },
              designationConfig: {
                ...field.designationConfig,
                y: field?.designationConfig?.y * canvas.scale,
                fontSize: field?.designationConfig?.fontSize * canvas.scale,
              },
              checkConfig: {
                ...field.checkConfig,
                width: field?.checkConfig?.width * canvas.scale,
                height: field?.checkConfig?.height * canvas.scale,
                marginRight: field?.checkConfig?.marginRight * canvas.scale,
              },
              inputConfig: {
                ...field.inputConfig,
                fontSize: field?.inputConfig?.fontSize * canvas.scale,
                width: field?.inputConfig?.width * canvas.scale,
                height: field?.inputConfig?.height * canvas.scale,
              },
            }}
            onSelectTextBox={() => onShowTextBox({ layerId, fieldId: index, type: field.type })}
            onSelect={shouldSign ? () => onShowSignature({ layerId, fieldId: index, type: field.type }) : undefined}
            onQuickSign={shouldSign ? () =>  onShowQuickSigning({ layerId, fieldId: index, type: field.type }) : undefined}
            onCheck={shouldSign ? () => onCheck({ layerId, fieldId: index, type: field.type }) : undefined}
            onTextFocus={shouldSign ? () => onTextFocus({ layerId, fieldId: index, type: field.type, value: true }) : undefined}
            onTextUpdate={shouldSign ? (value) => onTextUpdate({ layerId, fieldId: index, type: field.type, value }) : undefined}
          />
        );
      })}
    </Layer>
  );
};

export default memo(LayerCanvas);
